<template>
  <b-navbar
    wrapper-class="container"
    :close-on-click="false"
    :is-active.sync="showMenu"
  >
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <strong>My favorite album covers</strong>
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item tag="div">
        <albums-serch-input />
      </b-navbar-item>
      <b-navbar-dropdown label="Categories" class="is-hidden-desktop">
        <b-navbar-item
          @click="setSelectedCategory(null)"
          :active="selectedCategory === null"
        >
          All
        </b-navbar-item>
        <b-navbar-item
          v-for="(filter, index) in filters"
          :key="`filter-${index}`"
          @click="setSelectedCategory(filter)"
          :active="filter === selectedCategory"
        >
          {{ filter }}
        </b-navbar-item>
      </b-navbar-dropdown>
    </template>
  </b-navbar>
</template>

<script>
import AlbumsSerchInput from "@/components/AlbumsSerchInput";

export default {
  name: "TheNavbar",

  components: {
    AlbumsSerchInput
  },

  data() {
    return {
      showMenu: false
    };
  },

  computed: {
    selectedCategory() {
      return this.$store.state.selectedCategory;
    },
    filters() {
      return this.$store.state.filters;
    }
  },

  methods: {
    setSelectedCategory(category) {
      this.showMenu = false;
      this.$store.commit("setSelectedCategory", category);
    }
  }
};
</script>
